export default {
  state: {
    proyect: {},
    proyectContents: [],
    proyectNodes: [],
    proyectNodesEnrollment: [],
    proyectNodesEnrollmentNavigation: [],
    selectedNode: {},
    selectedProyect: {},
    studentEnrollments: []
  },

  getters: {
    getProyect (state) {
      return state.proyect
    },

    getProyectContents (state) {
      return state.proyectContents
    },

    getProyectNodes (state) {
      return state.proyectNodes
    },

    getProyectNodesEnrollment (state) {
      return state.proyectNodesEnrollment
    },

    getProyectNodesEnrollmentNavigation (state) {
      return state.proyectNodesEnrollmentNavigation
    },

    getSelectedNode (state) {
      return state.selectedNode
    },

    getSelectedProyect (state) {
      return state.selectedProyect
    },

    getStudentEnrollments (state) {
      return state.studentEnrollments
    }
  },

  mutations: {
    setProyect (state, proyect) {
      state.proyect = proyect
    },

    setProyectContents (state, proyectContents) {
      state.proyectContents = proyectContents
    },

    setProyectNodes (state, proyectNodes) {
      state.proyectNodes = proyectNodes
    },

    setProyectNodesEnrollment (state, proyectNodesEnrollment) {
      state.proyectNodesEnrollment = proyectNodesEnrollment
    },

    setProyectNodesEnrollmentNavigation (state, proyectNodesEnrollmentNavigation) {
      state.proyectNodesEnrollmentNavigation = proyectNodesEnrollmentNavigation
    },

    setSelectedNode (state, selectedNode) {
      state.selectedNode = selectedNode
    },

    setSelectedProyect (state, selectedProyect) {
      state.selectedProyect = selectedProyect
    },

    setStudentEnrollments (state, studentEnrollments) {
      state.studentEnrollments = studentEnrollments
    },

    unsetProyect (state) {
      state.proyect = {}
    },

    unsetProyectContents (state) {
      state.proyectContents = []
    },

    unsetProyectNodes (state) {
      state.proyectNodes = []
    },

    unsetProyectNodesEnrollment (state) {
      state.proyectNodesEnrollment = []
    },

    unsetProyectNodesEnrollmentNavigation (state) {
      state.proyectNodesEnrollmentNavigation = []
    },

    unsetSelectedNode (state) {
      state.selectedNode = {}
    },

    unsetSelectedProyect (state) {
      state.selectedProyect = {}
    },

    unsetStudentEnrollments (state) {
      state.studentEnrollments = []
    }
  }
}
